import authRules from '../authRules.js';

const editMode = (user) => {
  const { scheduleData } = user.securityLevels;
  if (scheduleData >= authRules.editMode.scheduleData) {
      return true;
  } else {
      return false;
    }
  }


export default editMode;
